/**
 * Where Artwork's tours point: the `data-tour` values on its real controls. Kept in one list so a
 * renamed anchor fails tours.test.ts instead of a tour quietly pointing at nothing.
 */
export { findAnchor } from '@flobi/asset-library/tours';

export const TOUR_ANCHORS = {
  getStarted: 'artwork.getStarted',
  composer: 'artwork.composer',
  newFile: 'artwork.newFile',
  dock: 'artwork.dock',
  shape: 'artwork.tool.shape',
  text: 'artwork.tool.text',
  selectionBar: 'artwork.selectionBar',
  rail: 'artwork.rail',
  railBrand: 'artwork.rail.brand',
  railGenerate: 'artwork.rail.generate',
  railTemplates: 'artwork.rail.templates',
  animate: 'artwork.animate',
  share: 'artwork.share',
  comment: 'artwork.comment',
  export: 'artwork.export',
} as const;
